import React, { useEffect, useState } from "react";
import { FieldArray, FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { PaymentDetailsFormValues } from "src/models/PaymentDetails.model";
import usePaymentModes from "src/hooks/usePaymentModes";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMTable from "src/components/UI/atoms/ATMTable/ATMTable";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import { GrFormAdd } from "react-icons/gr";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useGetAdvancePaymentMutation } from "src/services/OfflineOrderService";
import { regIndiaPhone } from "src/screens/OfflineOrders/Layouts/OfflineOrderForm";
import { getInputHeight } from "src/utils/formUtils/getInputHeight";
import { handleValidNumber2 } from "src/utils/formUtils/ValidNumber";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import PaymentModel from "src/screens/OfflineOrders/View/PaymentModel/PaymentDetailsModel";

type Props = {
  formikProps: FormikProps<PaymentDetailsFormValues>;
  coloumns: any;
  row: any;
  setMobileForAdv: any;
  mobileForAdv: any;
  advancedAmount: any;
  setAdvancedAmount: any;
  onlineMode: any;
};

const PaymentDetailsForm = ({
  onlineMode,
  formikProps,
  coloumns,
  row,
  setMobileForAdv,
  mobileForAdv,
  setAdvancedAmount,
  advancedAmount,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const navigate = useNavigate();
  const [showUpdatePayment, setShowUpdatePayment] = useState(false);
  const { orderId } = useParams();

  const [getAvancePayments, advancePaymentInfo] =
    useGetAdvancePaymentMutation();

  useEffect(() => {
    if (!advancePaymentInfo?.isLoading) {
      setAdvancedAmount(advancePaymentInfo?.data?.data);
      setFieldValue("totalAdvancePayment", advancePaymentInfo?.data?.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancePaymentInfo.isLoading]);

  // const { paymentMode: paymentModes, isDataLoading } = usePaymentModes();

  //payment modess
  // const PaymentModeOptions = paymentModes?.map((paymentMode: any) => {
  //   return {
  //     label: paymentMode?.paymentModeName,
  //     value: paymentMode?._id,
  //   };
  // });

  useEffect(() => {
    const totalAmount = values?.paymentMode?.reduce(
      (total: any, payment: any) => {
        // Convert the 'amount' property to a number before summing
        return total + Number(payment.amount);
      },
      0
    );
    setFieldValue("amountPaid", Number(totalAmount) || 0);

    const calculateTotalAmount =
      Number(values?.showRemainingFees) - Number(values?.receivedAmt);

    setFieldValue(
      "remainingFees",
      Number(calculateTotalAmount) > 0 ? Number(calculateTotalAmount) : 0
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.receivedAmt]);
  useEffect(() => {
    let amountPaid =
      Number(values?.showRemainingFees) - Number(values?.adjustAmount);
    setFieldValue("paymentMode[0].amount", amountPaid > 0 ? amountPaid : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.showRemainingFees, values?.adjustAmount]);

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <div className="border-l-[3px] border-primary-dark px-3 py-1 z-10  font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
          Payment Summary
        </div>
        <div>
          <div className="grid grid-cols-2">
            <div className="border border-slate-500 grid grid-cols-2 rounded-t">
              <div className="border-r-2  p-2 font-medium text-[15px]">
                Total Fees
              </div>
              <div className="p-2 text-center">
                &#8377;{values?.showTotalFees || 0}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className=" border-x  border-b border-slate-500 grid grid-cols-2">
              <div className="border-r-2  p-2 font-medium text-[15px]">
                Total discount
              </div>
              <div className="p-2 text-center">
                &#8377;{values?.discountAmt || 0}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className="border-x  border-b border-slate-500 grid grid-cols-2">
              <div className="border-r-2  p-2 font-medium text-[15px]">
                Courier Charges
              </div>
              <div className="p-2 text-center">
                &#8377;{values?.courierCharges || 0}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className=" border-x  border-b border-slate-500 grid grid-cols-2">
              <div className="border-r-2  p-2 font-medium text-[15px]">
                Total Paid
              </div>
              <div className="p-2 text-center">
                &#8377;{values?.showamountPaid || 0}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className=" border-x  border-b border-slate-500 grid grid-cols-2">
              <div className="border-r-2  p-2 font-medium text-[15px]">
                Adjust Advance payment
              </div>
              <div className="p-2 text-center">
                &#8377;{values?.adjustAmount || 0}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className=" border-x  border-b border-slate-500 grid grid-cols-2 rounded-b">
              <div className="border-r-2  p-2 font-medium text-[15px]">
                Total Remaining
              </div>
              <div className="p-2 text-center">
                &#8377;{values?.showRemainingFees || 0}
              </div>
            </div>
          </div>
        </div>

        {/* Payment History */}
        <div className="border-l-[3px] border-primary-dark px-3 py-1 z-10  font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
          Payment History
        </div>
        <div>
          <div className="flex justify-end items-center gap-4">
            <ATMLoadingButton
              className="w-40"
              onClick={(e) => {
                navigate(`/download-receipt/${orderId}`);
              }}
            >
              Download Receipt
            </ATMLoadingButton>
            {Number(values?.showTotalFees) - Number(values?.discountAmt) !==
            Number(values?.showamountPaid) + Number(values.adjustAmount) ? (
              <ATMLoadingButton
                className="w-24"
                onClick={() => {
                  setShowUpdatePayment(true);
                }}
              >
                Add
              </ATMLoadingButton>
            ) : null}
          </div>
          {/* Table */}
          <div className="flex-1 overflow-auto flex flex-col px-4 my-2">
            <ATMTable columns={coloumns} rows={row} />
          </div>
        </div>
        {showUpdatePayment ? (
          <div className="shadow-md p-3">
            <div className="border-l-[3px] border-primary-dark px-3 py-1 z-10  font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
              Update Payment
            </div>
            <div>
              {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4  my-5">
                <div>
                  <div className="flex gap-2 items-center">
                    <ATMTextField
                      name="mobileForAdv"
                      placeholder="Please enter Mobile Number"
                      maxLength={10}
                      value={mobileForAdv}
                      onChange={(e) =>
                        handleValidNumber2(e) && setMobileForAdv(e.target.value)
                      }
                      label="Search Advance Payment"
                      onBlur={handleBlur}
                    />
                    <div className="mt-5">
                      <ATMLoadingButton
                        className="w-fit "
                        disabled={!mobileForAdv.match(regIndiaPhone)}
                        onClick={() => {
                          getAvancePayments({
                            mobile: mobileForAdv,
                          });
                          setFieldValue(`adjustAgainstMobile`, mobileForAdv);
                          setFieldValue("adjustAmount", 0);
                        }}
                        isLoading={advancePaymentInfo?.isLoading}
                      >
                        Search
                      </ATMLoadingButton>
                    </div>
                  </div>
                  <span>
                    <span className="text-sm font-medium">
                      Total Advance Amount
                    </span>{" "}
                    : &#8377;{advancedAmount || 0}
                  </span>
                </div>
                <div>
                  <ATMTextField
                    name="adjustAmount"
                    value={values?.adjustAmount}
                    onChange={(e) => {
                      setFieldValue("adjustAmount", e.target.value);
                    }}
                    label="Advance Amount"
                    onBlur={handleBlur}
                    placeholder="Please enter AdvanceAmount"
                  />
                </div>
              </div> */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-2 mt-4">
                <div>
                  <ATMTextField
                    name="receivedAmt"
                    required
                    value={values?.receivedAmt}
                    onChange={(e) =>
                      handleValidNumber2(e) &&
                      setFieldValue(`receivedAmt`, e.target.value)
                    }
                    label="Amount"
                    placeholder="Enter Amount"
                    onBlur={handleBlur}
                  />
                </div>

                <div>
                  <ATMTextField
                    name="remainingFees"
                    value={values?.remainingFees}
                    onChange={(e) => {
                      setFieldValue("remainingFees", e.target.value);
                    }}
                    label="Remaning fees"
                    onBlur={handleBlur}
                    disabled
                  />
                </div>
              </div>
              <PaymentModel formikProps={formikProps} onlineMode={onlineMode} />
              <div className="mt-5">
                <ATMTextArea
                  name="remark"
                  value={values?.remark}
                  required
                  onChange={(e) => {
                    setFieldValue("remark", e);
                  }}
                  label="Remark"
                />
              </div>
              <div className="flex justify-end">
                <ATMLoadingButton
                  className="w-28"
                  isLoading={isSubmitting}
                  type="submit"
                >
                  Update
                </ATMLoadingButton>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PaymentDetailsForm;
